import { Text } from "@chakra-ui/react";
import { CircleQuestionMarkIcon } from "lucide-react";
import Tooltip from "./Tooltip";

type DateCardProps = {
	date: Date;
	showReceiptTime?: boolean;
};

const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
	weekday: "long",
	year: "numeric",
	month: "short",
	day: "numeric",
});
const dayFormat = new Intl.DateTimeFormat(undefined, {
	day: "2-digit",
});
const monthFormat = new Intl.DateTimeFormat(undefined, {
	month: "short",
});

const DateCard = ({ date, showReceiptTime = true }: DateCardProps) => {
	const content = showReceiptTime
		? "Estimation = Temps réception moyen + Temps de fabrication moyen + Temps d'expédition moyen"
		: "Estimation = Temps de fabrication moyen + Temps d'expédition moyen";

	return (
		<div className="flex flex-row gap-4 items-center">
			<div className="border! border-gray-300! w-24 h-24 rounded-xl">
				<Text
					fontSize="14px"
					fontWeight={600}
					className="bg-brand-700 text-white text-center py-1 rounded-t-xl uppercase"
				>
					{monthFormat.format(date).replace(".", "").slice(0, 3)}
				</Text>
				<Text
					fontSize="48px"
					fontWeight={600}
					className="text-brand-700 text-center py-0"
				>
					{dayFormat.format(date)}
				</Text>
			</div>
			<div>
				<div className="flex flex-row items-center gap-2">
					<Text fontSize="16px" fontWeight={600} className="text-gray-600">
						Livraison estimée
					</Text>
					<Tooltip fontSize="14px" content={content}>
						<CircleQuestionMarkIcon className="text-gray-400 w-3.5 h-3.5" />
					</Tooltip>
				</div>
				<Text
					fontSize="24px"
					fontWeight={600}
					className="text-brand-700 capitalize"
				>
					{dateTimeFormat.format(date)}
				</Text>
			</div>
		</div>
	);
};

export default DateCard;
